import { createReducer, INITIAL_STATE } from '@shared/redux';

export const INTEGRATIONS_ONBOARDING_MODAL_OPENED = '@integrations/INTEGRATIONS_ONBOARDING_MODAL_OPENED';
export const INTEGRATIONS_ONBOARDING_MODAL_CLOSED = '@integrations/INTEGRATIONS_ONBOARDING_MODAL_CLOSED';

export const SET_INTEGRATIONS_ONBOARDING_MODAL_PLATFORM = '@integrations/SET_INTEGRATIONS_ONBOARDING_MODAL_PLATFORM';
export const REDIRECT_OR_OPEN_ONBOARDING_MODAL = '@integrations/REDIRECT_OR_OPEN_ONBOARDING_MODAL';

export const
    isIntegrationsOnboardingModalOpen = state => state.integrations.onboardingModal?.isModalOpen;
export const
    getIntegrationsOnboardingModalPlatform = state => state.integrations.onboardingModal?.platform;

export const openIntegrationsOnboardingModal = () => ({
    type: INTEGRATIONS_ONBOARDING_MODAL_OPENED,
    payload: {},
});

export const closeIntegrationsOnboardingModal = () => ({
    type: INTEGRATIONS_ONBOARDING_MODAL_CLOSED,
    payload: {},
});

export const redirectOrOpenOnboardingModal = platform => ({
    type: REDIRECT_OR_OPEN_ONBOARDING_MODAL,
    payload: { platform },
});

export const integrationsOnboardingModalReducer = createReducer({
    [INITIAL_STATE]: {
        isModalOpen: false,
        error: null,
        loading: false,
        platform: null,
    },
    [INTEGRATIONS_ONBOARDING_MODAL_OPENED]: state => ({
        ...state,
        isModalOpen: true,
    }),
    [INTEGRATIONS_ONBOARDING_MODAL_CLOSED]: state => ({
        ...state,
        isModalOpen: false,
    }),
    [REDIRECT_OR_OPEN_ONBOARDING_MODAL]: (state, action) => ({
        ...state,
        platform: action.payload.platform,
    }),
});
